import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useFormContext } from '../../state';

type Links = {
  privacyLink: string;
  websiteLink: string;
};

const LINKS: Record<string, Links> = {
  GB: {
    privacyLink: 'https://www.treatwell.co.uk/info/privacy-policy/',
    websiteLink:
      'https://www.treatwell.co.uk/info/supplier-terms-and-conditions/',
  },
  FR: {
    privacyLink: 'https://www.treatwell.fr/info/politique-de-confidentialite/',
    websiteLink:
      'https://www.treatwell.fr/info/termes-et-conditions-salons-partenaires/',
  },
  IE: {
    privacyLink: 'https://www.treatwell.ie/info/privacy-policy/',
    websiteLink: 'https://www.treatwell.ie/info/supplier-terms-and-conditions/',
  },
  LT: {
    privacyLink: 'https://www.treatwell.lt/info/privatumo-politika/',
    websiteLink: 'https://www.treatwell.lt/info/partneriu-nuotatos-ir-salygos/',
  },
  IT: {
    privacyLink: 'https://www.treatwell.it/info/norme-privacy/',
    websiteLink: 'https://www.treatwell.it/info/termini-legali-del-fornitore/',
  },
  GR: {
    privacyLink: 'https://www.treatwell.gr/info/politikh-aporrhtoy/',
    websiteLink:
      'https://www.treatwell.gr/info/oroi-kai-proypotheseis-promhtheyth/',
  },
  NL: {
    privacyLink: 'https://www.treatwell.nl/info/privacy-policy/',
    websiteLink: 'https://www.treatwell.nl/info/algemene-voorwaarden-salons/',
  },
  ES: {
    privacyLink: 'https://www.treatwell.es/info/politica-de-privacidad/',
    websiteLink:
      'https://www.treatwell.es/info/terminos-y-condiciones-para-profesionales/',
  },
  PT: {
    privacyLink: 'https://www.treatwell.pt/info/politica-de-privacidade/',
    websiteLink:
      'https://www.treatwell.pt/info/termos-e-condicoes-para-fornecedores/',
  },
  AT: {
    privacyLink: 'https://www.treatwell.at/info/datenschutzrichtlinien/',
    websiteLink: 'https://www.treatwell.at/info/vertragsbestimmungen/',
  },
  DE: {
    privacyLink: 'https://www.treatwell.de/info/datenschutz/',
    websiteLink: 'https://www.treatwell.de/info/vertragsbestimmungen/',
  },
  CH: {
    privacyLink: 'https://www.treatwell.ch/info/datenschutzrichtlinien/',
    websiteLink: 'https://www.treatwell.ch/info/vertragsbestimmungen/',
  },
  LV: {
    privacyLink: 'https://www.treatwell.co.uk/info/privacy-policy/',
    websiteLink:
      'https://www.treatwell.co.uk/info/supplier-terms-and-conditions/',
  },
};

export function Privacy(): JSX.Element {
  const {
    data: {
      address: { countryCode },
    },
  } = useFormContext();
  const { t } = useTranslation('input', { keyPrefix: 'privacy' });

  const links = LINKS[countryCode] || LINKS.GB;

  return (
    <div className="aura--copy-xs">
      <Trans
        t={t}
        i18nKey="label"
        components={[
          <a href={links.privacyLink} target="_blank" />,
          <a href={links.websiteLink} target="_blank" />,
        ]}
      />
    </div>
  );
}
